/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Properties of a GCP Disk when discovered as a standalone resource. Present only when `resourceType` is set to `GCP_DISK`. 
*/
export class GcpDiskResource {
  /**
  * The unique identifier for the disk.
  */
  'diskId': string;
  /**
  * The name of the disk.
  */
  'diskName': string;
  /**
  * The type of the disk.
  */
  'diskType': GcpDiskResourceDiskTypeEnum;
  /**
  * The size of the disk in gigabytes.
  */
  'sizeGb': number;
  /**
  * The region where the disk is located.
  */
  'region': string;
  /**
  * The zone where the disk is located.
  */
  'zone'?: string;
  /**
  * The status of the disk.
  */
  'status': GcpDiskResourceStatusEnum;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "diskId",
      "baseName": "diskId",
      "type": "string",
      "format": ""
    },
    {
      "name": "diskName",
      "baseName": "diskName",
      "type": "string",
      "format": ""
    },
    {
      "name": "diskType",
      "baseName": "diskType",
      "type": "GcpDiskResourceDiskTypeEnum",
      "format": ""
    },
    {
      "name": "sizeGb",
      "baseName": "sizeGb",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "zone",
      "baseName": "zone",
      "type": "string",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "GcpDiskResourceStatusEnum",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpDiskResource.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum GcpDiskResourceDiskTypeEnum {
  PdStandard = 'pd-standard',
  PdBalanced = 'pd-balanced',
  PdSsd = 'pd-ssd',
  PdExtreme = 'pd-extreme',
  HyperdiskBalanced = 'hyperdisk-balanced',
  HyperdiskBalancedHighAvailability = 'hyperdisk-balanced-high-availability',
  HyperdiskExtreme = 'hyperdisk-extreme',
  HyperdiskMl = 'hyperdisk-ml',
  HyperdiskThroughput = 'hyperdisk-throughput'
}
export enum GcpDiskResourceStatusEnum {
  Creating = 'CREATING',
  Restoring = 'RESTORING',
  Failed = 'FAILED',
  Ready = 'READY',
  Deleting = 'DELETING'
}

